<template>
  <ul class="ul-table" v-if="items && items.length > 0">
    <div v-if="type == 'number'">
      <li v-for="(v, k) in items" :key="k">
        {{ v[keyName] | thousandSeparator }}
      </li>
    </div>
    <div v-if="type == 'text'">
      <li v-for="(v, k) in items" :key="k">
        {{ v[keyName] }}
      </li>
    </div>
  </ul>
</template>
<script>
export default {
  props: ["items", "keyName", "type"],
};
</script>